import { memo } from 'react';

import { SearchBar as AntdSearchBar, SearchBarProps } from 'antd-mobile';
import classNames from 'classnames';

import { createDesign, useTrans } from '@/hooks';

import './index.scss';

const { prefixCls } = createDesign('cmp-search-bar');

interface Props extends SearchBarProps {
  className?: string;
}

function SearchBar(props: Props) {
  const { t } = useTrans();
  return (
    <div className={classNames(prefixCls, props?.className)}>
      <AntdSearchBar {...props} placeholder={t(props?.placeholder || '')} />
    </div>
  );
}

export default memo(SearchBar);
